/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

// Importation de datatables
import 'datatables.net-bs4/js/dataTables.bootstrap4.js';
import 'datatables.net-responsive-bs4/js/responsive.bootstrap4.js';

// Pour Select2
import 'select2/dist/js/select2.js';

// Daterangepicker
//import 'daterangepicker/daterangepicker.js';
import 'bootstrap-daterangepicker/daterangepicker.js';

import 'moment/moment.js';

window.moment = require('moment');
window.moment.locale('fr');
window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});
